import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { StateIndicatorIconComponent } from '@mode/shared/ui';
import {
  NotebookAddCellButtonComponent,
  NotebookCellMarkdownComponent,
  NotebookCellMenuComponent,
  NotebookCellRendererComponent,
  NotebookCellResultComponent,
  NotebookCellWarningComponent,
  NotebookContainerComponent,
  NotebookIncludedReportCellButtonComponent,
  NotebookRunCellButtonComponent,
  NotebookSupportedLibrariesComponent,
  NotebookSidebarComponent,
  NotebookToolbarMoreDropdownComponent,
  NotebookSecretsComponent,
  NotebookUseOutputMenuComponent,
  NotebookEditorCellComponent,
  NotebookToolbarComponent,
  NotebookCellGroupComponent,
  NotebookComponent,
  NotebookImportModalComponent,
} from '@mode/notebooks/feature-notebooks';

export const DowngradedNotebooksUiModule = angular
  .module('downgraded-notebooks-ui', [])
  .directive('modeNotebookAddCellButton', downgradeComponent({ component: NotebookAddCellButtonComponent }))
  .directive('modeNotebookCellMarkdown', downgradeComponent({ component: NotebookCellMarkdownComponent }))
  .directive('modeNotebookCellMenu', downgradeComponent({ component: NotebookCellMenuComponent }))
  .directive('modeNotebookCellRenderer', downgradeComponent({ component: NotebookCellRendererComponent }))
  .directive('modeNotebookCellResult', downgradeComponent({ component: NotebookCellResultComponent }))
  .directive('modeNotebookCellWarning', downgradeComponent({ component: NotebookCellWarningComponent }))
  .directive('modeNotebookContainer', downgradeComponent({ component: NotebookContainerComponent }))
  .directive(
    'modeNotebookIncludedReportCellButton',
    downgradeComponent({ component: NotebookIncludedReportCellButtonComponent })
  )
  .directive('modeNotebookUseOutputMenu', downgradeComponent({ component: NotebookUseOutputMenuComponent }))
  .directive('modeNotebookRunCellButton', downgradeComponent({ component: NotebookRunCellButtonComponent }))
  .directive('modeNotebookSidebar', downgradeComponent({ component: NotebookSidebarComponent }))
  .directive('modeNotebookSupportedLibraries', downgradeComponent({ component: NotebookSupportedLibrariesComponent }))
  .directive('modeStateIndicatorIcon', downgradeComponent({ component: StateIndicatorIconComponent }))
  .directive('modeNotebookSecrets', downgradeComponent({ component: NotebookSecretsComponent }))
  .directive('modeNotebookEditorCell', downgradeComponent({ component: NotebookEditorCellComponent }))
  .directive('modeNotebookToolbar', downgradeComponent({ component: NotebookToolbarComponent }))
  .directive('modeNotebookCellsGroup', downgradeComponent({ component: NotebookCellGroupComponent }))
  .directive('modeNotebookV2', downgradeComponent({ component: NotebookComponent }))
  .directive('modeNotebookImportModal', downgradeComponent({ component: NotebookImportModalComponent }))
  .directive(
    'modeNotebookToolbarMoreDropdown',
    downgradeComponent({ component: NotebookToolbarMoreDropdownComponent })
  ).name;
